/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DecimalInput, DropDown2, Input2, ToggleButton } from "components";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_TEXT_PREFIXED } from "config";

export const OfferXForTextBuilder = ({
  className,
  value,
  onChange = () => {},
}) => {
  const amount = useInput("");
  const val = useInput("");
  const isPurchase = useInput(false);
  const purchaseAmount = useInput("");
  const product = useInput("");
  const purchaseType = useInput("");
  const selectedCoupon = useInput("");

  const handleUpdateValue = (amount, value, isP, purchase, product, purchaseType = '', coupon) => {
    if (amount && value) {
      if (isP) {
        if (!purchase && !product) {
          onChange(`${amount}/$${value} w/purchase/${coupon ? `${coupon}` : ""}`.trim());
          return;
        }
        onChange(
          `${amount}/$${value} w/purchase/${purchaseType}${purchase}${
            product ? ` ${product}` : ""
          } ${coupon ? `${coupon}` : ""}`.trim()
        );
      } else {
        if (product) {
          onChange(`${amount}/$${value} for ${product ? `${product}` : ""} ${coupon ? `${coupon}` : ""}`.trim());
        } else if (coupon) {
          onChange(`${amount}/$${value} w/purchase/${coupon}`.trim());
        } else {
          onChange(`${amount}/$${value}`);
        }
      }
    }
  };

  useEffect(() => {
    if (value) {
      const couponTrimmed = ALL_COUPON_TYPES_TEXT_PREFIXED.map((c) => c.title);
      couponTrimmed.forEach((ct) => {
        if (value.includes(ct)) {
          selectedCoupon.setValue(ct);
          value = value.replace(ct, "").trim();
        }
      });
      const pIdx = value.indexOf("w/purchase/");
      if (pIdx > 0) {
        isPurchase.setValue(true);
        let v = value.slice(0, pIdx).trim();
        const splits = v.split("/$");
        if (splits.length === 2) {
          amount.setValue(splits[0].trim());
          val.setValue(splits[1].trim());
        }
        const p = value.slice(pIdx + 11).trim();

        const sufIdx = p.indexOf(" ");
        let purchaseTypeStr = "";
        if (sufIdx > 0) {
          let purchaseTxt = p.slice(0, sufIdx).trim();
          if (purchaseTxt[0] === "$") {
            purchaseTypeStr = "$";
            purchaseType.setValue("$");
            purchaseTxt = purchaseTxt.slice(1).trim();
          }
          purchaseAmount.setValue(purchaseTxt);
          product.setValue(p.slice(sufIdx + 1).trim());
        } else {
          if (p[0] === "$") {
            purchaseTypeStr = "$";
            purchaseType.setValue("$");
            purchaseAmount.setValue(p.slice(1).trim());
          } else {
            purchaseAmount.setValue(p);
          }
          product.setValue("");
        }
      } else {
        isPurchase.setValue(false);
        const sufIdx = value.indexOf(" ");
        let v = "";
        if (sufIdx > 0) {
          v = value.slice(0, sufIdx);
          product.setValue(value.slice(sufIdx + 1).trim());
        } else {
          v = value;
          product.setValue("");
        }
        const splits = v.split("/$");
        if (splits.length === 2) {
          amount.setValue(splits[0].trim());
          val.setValue(splits[1].trim());
        }
      }
    }
    return () => {};
  }, []);

  return (
    <div className={`${className} mt-1`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div style={{ width: 100, marginRight: 10 }}>
          <Input2
            label="Amount"
            type="float"
            value={amount.value}
            onChange={(e) => {
              amount.setValue(e);
              handleUpdateValue(
                e,
                val.value,
                isPurchase.value,
                purchaseAmount.value,
                product.value,
                purchaseType.value,
                selectedCoupon.value
              );
            }}
          />
        </div>
        <div className="mt-auto mb-1">/</div>
        <div style={{ width: 100, marginLeft: 10 }}>
          <DecimalInput
            label="Value"
            value={val.value}
            onChange={(e) => {
              val.setValue(e);
              handleUpdateValue(
                amount.value,
                e,
                isPurchase.value,
                purchaseAmount.value,
                product.value,
                purchaseType.value,
                selectedCoupon.value
              );
            }}
          />
        </div>
      </Container>
      <Container className="mt-2">
        <ToggleButton
          label="w/purchase/"
          className="mt-auto mb-2"
          value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(
              amount.value,
              val.value,
              e,
              purchaseAmount.value,
              product.value,
              purchaseType.value,
              selectedCoupon.value
            );
          }}
          />
        {/* Add toggle button to puchaseType to $ or '' */}
        <ToggleButton
          label={'$'}
          className="mt-auto mb-2 ml-2"
          value={purchaseType.value === "$"}
          onChange={(e) => {
            const value = e ? "$" : "";
            purchaseType.setValue(value);
            purchaseAmount.setValue('');
            handleUpdateValue(
              amount.value,
              val.value,
              isPurchase.value,
              '',
              product.value,
              value,
              selectedCoupon.value
            );
          }}
        />

        <div style={{ width: 110, marginLeft: 10, marginRight: 10 }}>
          {purchaseType.value === "$" ? (
            <DecimalInput
              label="Purchase Amount"
              disabled={!isPurchase.value}
              value={purchaseAmount.value}
              onChange={(e) => {
                purchaseAmount.setValue(e);
                handleUpdateValue(
                  amount.value,
                  val.value,
                  isPurchase.value,
                  e,
                  product.value,
                  purchaseType.value,
                  selectedCoupon.value
                );
              }}
            />
          ) : (
            <Input2
              label="Purchase Quantity"
              disabled={!isPurchase.value}
              value={purchaseAmount.value}
              onChange={(e) => {
                purchaseAmount.setValue(e);
                handleUpdateValue(
                  amount.value,
                  val.value,
                  isPurchase.value,
                  e,
                  product.value,
                  purchaseType.value,
                  selectedCoupon.value
                );
              }}
            />
          )
          }
        </div>
        <div className="mt-auto mb-2">for</div>
        <div style={{ width: 90, marginLeft: 10 }}>
          <Input2
            label="Product"
            value={product.value}
            onChange={(e) => {
              product.setValue(e);
              handleUpdateValue(
                amount.value,
                val.value,
                isPurchase.value,
                purchaseAmount.value,
                e,
                purchaseType.value,
                selectedCoupon.value
              );
            }}
          />
        </div>
      </Container>
      <Container>
        <DropDown2
          label={"Coupon Type"}
          value={selectedCoupon.value}
          data={ALL_COUPON_TYPES_TEXT_PREFIXED}
          onChange={(e) => {
            selectedCoupon.setValue(e);
            handleUpdateValue(
              amount.value,
              val.value,
              isPurchase.value,
              purchaseAmount.value,
              product.value,
              purchaseType.value,
              e
            );
          }}
        />
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
